import {
  Button,
  Dialog,
  Tabs,
  TabPane,
  Table,
  TableColumn,
  Row,
  Col,
  Input,
  Form,
  FormItem,
  RadioGroup,
  Radio,
  DatePicker,
  Pagination,
  Select,
  Option,
  Rate,
  Message
} from 'element-ui'
import zhTWLang from 'element-ui/lib/locale/lang/zh-TW'
import locale from 'element-ui/lib/locale'

export default {
  install (Vue, tool) {
    switch (tool) {
      case 'index':
        Vue.use(Input)
        Vue.use(Form)
        Vue.use(FormItem)
        break

      case 'presentation':
        Vue.use(Dialog)
        Vue.use(DatePicker)
        Vue.use(Tabs)
        Vue.use(TabPane)
        Vue.use(Table)
        Vue.use(TableColumn)
        Vue.use(Row)
        Vue.use(Col)
        Vue.use(Input)
        Vue.use(Form)
        Vue.use(FormItem)
        Vue.use(RadioGroup)
        Vue.use(Radio)
        Vue.use(Select)
        Vue.use(Option)
        Vue.use(Pagination)
        break

      case 'eyes-contact':
        Vue.use(Rate)
        break
    }

    Vue.use(Button)

    Vue.prototype.$message = Message

    locale.use(zhTWLang)
  }
}
